/* eslint-disable @typescript-eslint/no-namespace */
import {IBaseLookup} from '../lookups/lookups.types/interfaces/Ibase.lookup';

export namespace OrganizationStructure {

	export const lookupName:string = "OrganizationStructure";

	export interface OrgStructure {
		orgStructureKey:number;
		parentOrgStructureKey:number;
		code:string;
		description:string;
		address:Address;
		useParentLocation:string;
		lastUpdated:Date;
		displayPathName:string;
		allowOrders:string;
		facilityFlag:string;
		defaultFolderLocationKey:number;
		phoneNumber:string;
		certificationNumberKey:number;
		orgStructureItemTypeKey:number;
	}

	export interface OrgStructureXProviderId {
		orgStructXProviderIdKey:number;
		orgStructureKey:number;
		providerIdKey:number;
		lastUpdated:Date;
	}

	export interface Address {
		floor:string;
		building:string;
		streetAddress:string;
		otherDestination:string;
		city:string;
		province:string;
		country:number;
		postalCode:string;
	}

	export interface OrganizationStructureDS extends IBaseLookup {
		orgStructure:OrgStructure[];
		orgStructureXProviderId:OrgStructureXProviderId[];
	}
}
